import { baseApi } from "../baseApi";

type Coordinate = {
  latitude: number;
  longitude: number;
};

type DistanceParams =
  | { location_ids: number[] }
  | { coordinates: Coordinate[] };

type DistanceResponse = {
  distance: number;
  duration: number;
}[];

const locationsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getDistances: builder.mutation<DistanceResponse, DistanceParams>({
      query: (params) => ({
        url: "locations/distances",
        method: "POST",
        body: params
      }),
    }),
  }),
});

export const {
  useGetDistancesMutation,
} = locationsApi;
